import React, { Component } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import Main from './Main';
import Modal from './Modal';
import iconsKeywords from '../iconsKeywords.json';
import '../App.css';

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      iconsWidth: 48,
      iconsHeight: 48,
      iconsLinecap: "square",
      iconsJoin: "miter",
      iconsBorder: 2,
      iconsColor: "#2329D6",
      listOfSvgs: Object.keys(iconsKeywords),
      keywords: iconsKeywords,
      selectedSvgs: [],
      showModal: false,
      sidebarOpen: false,
      darkMode: false,
      searchKey: ""
    }
  }

  render() {
    return (
      <div className="wrapper">
        <Modal
            show={this.state.showModal}
            hideModal={ () => { this.setState({showModal: false}) } }
        />

        <Header 
          appState={this.state}
          updateAppState={(sidebarState) => this.getSidebarState(sidebarState)}
        />
        <div className="content" id="content">
            <div className="content__wrapper">
                <Sidebar
                    listOfSvgs={this.state.listOfSvgs}
                    updateAppState={(sidebarState) => this.getSidebarState(sidebarState)}
                    appState={this.state}
                    showModal={ ()=>{ this.setState({showModal: true}) } }
                    sidebarOpen={this.state.sidebarOpen}
                    darkMode={this.state.darkMode}
                />

                <Main
                    iconsData={this.state}
                    selectSvg={ (svgName)=>{ this.selectSvg(svgName) } }
                    selectedSvgs={this.state.selectedSvgs}
                    searchKey={this.state.searchKey}
                    keyWords={this.state.keywords}
                    darkMode={this.state.darkMode}
                />
            </div>
            <button
                className="content__nav-drawer"
                style={{display: this.state.sidebarOpen && 'none' }}
                onClick={e => {
                    this.setState({sidebarOpen: true});
                }}>
                Customise &amp; Export
            </button>
        </div>
    </div>
    );
  }


  getSidebarState (sidebarState) {
    this.setState(sidebarState);
  }


  selectSvg(svgName){
      const index = this.state.selectedSvgs.indexOf(svgName)
      if(index < 0){//if svg isn't in array
          this.state.selectedSvgs.push(svgName)
          this.forceUpdate();
      }else{
          this.state.selectedSvgs.splice(index, 1)
          this.forceUpdate();
      }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/Homepage.js